import React, {useContext} from 'react'
import { MouseContext } from "../context/mouseContext" //cursor 

const Footer = () => {
    const { cursorChangeHandler } = useContext(MouseContext); //cursor
    return (
        <footer className="text-center">
               <p   className='mb-0 py-2'>© 2022 developed by <a 
                    href="https://baher-essam.com/"
                    rel="noreferrer noopener"
                    onMouseEnter={() => cursorChangeHandler("hovered")}
                    onMouseLeave={() => cursorChangeHandler("")}
                    className='font-400'
                    target="_blank"
                >
                         Baher Essam
                </a>
                </p>
        </footer>
    )
}

export default Footer